<template>
  <div>
    <section class="padd-top-20">
      <div class="container">
  
        <div class="col-md-6 col-sm-12">
          <h3>{{ $t('nav.contact') }}</h3>
          <p>ACCA会不断努力为我们的客户提供最优质的服务和支持。如果有关于“ACCA 职位公告板”（“ACCA Careers-China Job Board”）的问题，请联系：</p>
          <p>邮箱: <a href="javascript:void(0)">cnjobboardsupport@accaglobal.com</a></p>
          <p>&nbsp;</p>
          <p>工作时间：星期一至星期五: 8:00am - 8:00pm，周六，周日及中国法定节假日 9:30am - 6:00pm。</p>
        </div>
        
      </div>
    </section>
  </div>
  </template>
  <script>
  //import Map from '@/components/Map.vue'
  export default {
    name: 'ContactInfo',
    data: () => ({
    formData: {
      'name': '',
      'email': '',
      'message': ''
    }
    }),
    components: {
    },
    methods: {
      sendMessage: function() {
        this.$validator.validate().then(result => {
          if (!result) {
            // do stuff if not valid.
            this.$message({
              message: this.$t('contact.invalid'),
              type: 'error'
            })
          } else {
            this.$message({
              message: this.$t('contact.sucess'),
              type: 'success'
            })
          }
        })
      },
      resetForm: function() {
        this.formData = {
        'name': '',
        'email': '',
        'message': ''
      }
      }
    }
  }
  </script>